import React, { useEffect, useState } from "react";
import { api } from "@/api/client.js";
import { DataTable } from "@/components/DataTable.jsx";
import { useOrignalUi } from "@/hooks/useOrignalUi.js";
import { localizeDemo } from "@/i18n/orignalI18n.js";

export function HistoryPage() {
  const { ui, lang } = useOrignalUi();
  const [items, setItems] = useState([]);
  useEffect(() => {
    api("/api/activity").then((d) => setItems(d.items)).catch(() => {});
  }, []);
  return (
    <main className="og-page" data-testid="page-history">
      <h1>{ui.history.title}</h1>
      <p className="og-lead">{ui.history.subtitle}</p>
      <p className="og-hint" data-historical="prospect" data-testid="history-avenza">{ui.history.avenzaPast}</p>
      <DataTable
        rows={items.map((a) => ({ ...a, label: localizeDemo(a.label, lang) }))}
        searchKeys={["label", "action", "entity_type"]}
        columns={[
          { key: "created_at", label: ui.today.dates },
          { key: "action", label: ui.history.title },
          { key: "label", label: ui.expenses.description },
        ]}
        filters={[{ key: "entity_type", options: ["app", "territory_point", "media", "expense", "task", "message"].map((v) => ({ value: v, label: v })) }]}
        emptyLabel={ui.history.empty}
        testId="history-table"
      />
    </main>
  );
}
